import React from 'react';
import PropTypes from 'prop-types';
import './ShapeSelect.scss';
import shapes from './shapes';

const ShapeSelect = props => (
  <div className={`ShapeSelect${props.selected ? ' selected' : ''}`} onClick={props.onClick}>
    <div className="shape-container">
      <div className="shape">
        {shapes[props.shape]}
      </div>
      <div className="checkmark">
        <i className="material-icons">done</i>
      </div>
    </div>

    <div className="shape-label">{props.label}</div>
  </div>
);

export default ShapeSelect;

ShapeSelect.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  shape: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};
